import { render, staticRenderFns } from "./WizardEmailConfigStep.vue?vue&type=template&id=549e82ee&"
import script from "./WizardEmailConfigStep.vue?vue&type=script&lang=js&"
export * from "./WizardEmailConfigStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/xbill/public_html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('549e82ee')) {
      api.createRecord('549e82ee', component.options)
    } else {
      api.reload('549e82ee', component.options)
    }
    module.hot.accept("./WizardEmailConfigStep.vue?vue&type=template&id=549e82ee&", function () {
      api.rerender('549e82ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/wizard/WizardEmailConfigStep.vue"
export default component.exports